import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';
import template from './sign-up.component.html';
var SignUpComponentController = /** @class */ (function () {
    function SignUpComponentController() {
        this.loading = false;
        this.webStoreApiClient = getWebStoreApiClient();
    }
    Object.defineProperty(SignUpComponentController.prototype, "label", {
        get: function () {
            var _a;
            return (_a = this.customLabel) !== null && _a !== void 0 ? _a : "SignUp" /* SignUp */;
        },
        enumerable: false,
        configurable: true
    });
    SignUpComponentController.prototype.getMessage = function () {
        var _a;
        return (_a = this.guestDeniedMessage) !== null && _a !== void 0 ? _a : '';
    };
    SignUpComponentController.prototype.onSignUp = function () {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.webStoreApiClient.signUp();
    };
    SignUpComponentController.$inject = [];
    return SignUpComponentController;
}());
export var SignUpComponent = {
    bindings: {
        customLabel: '<',
        guestDeniedMessage: '<?',
    },
    controller: SignUpComponentController,
    template: template,
};
